/* unplugin-vue-components disabled */import { render } from "./CameraComponent.vue?vue&type=template&id=1c4d42f9&scoped=true"
import script from "./CameraComponent.vue?vue&type=script&lang=js"
export * from "./CameraComponent.vue?vue&type=script&lang=js"

import "./CameraComponent.vue?vue&type=style&index=0&id=1c4d42f9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d42f9"]])

export default __exports__